<!--
Modal for adding a recipe to a meal plan: pick an existing recipe, then a date,
meal slot and optional servings. Same fixed-overlay pattern as Action_modal.vue.

<MealPlanEntryModal v-if="show..."
    :recipes="recipes"
    :given_date="date or null"
    :given_slot="slot or null"
    v-on:save="entry => ..."
    v-on:decline-action="show... = false"
/>
-->
<template>
    <div class="popup">
        <div class="entry_modal">
            <h4>{{ $t('meal_plans.add_recipe') }}</h4>

            <div v-if="!picked_recipe">
                <input
                    type="text"
                    class="search_input"
                    v-model="query"
                    :placeholder="$t('meal_plans.search_recipes')"
                />
                <ul class="recipe_options">
                    <li v-for="recipe in filteredRecipes" :key="recipe.id" @click="picked_recipe = recipe">
                        {{ recipe.name }}
                    </li>
                    <li v-if="filteredRecipes.length < 1" class="no_results">{{ $t('meal_plans.no_recipes_found') }}</li>
                </ul>
            </div>

            <div v-else>
                <p class="picked_name">
                    {{ picked_recipe.name }}
                    <button type="button" class="change_link" @click="picked_recipe = null">{{ $t('meal_plans.change_recipe') }}</button>
                </p>
                <div class="field">
                    <label>{{ $t('meal_plans.date') }}</label>
                    <input type="date" v-model="date" />
                </div>
                <div class="field">
                    <label>{{ $t('meal_plans.slot') }}</label>
                    <select v-model="slot">
                        <option :value="null">{{ $t('meal_plans.slots.none') }}</option>
                        <option value="breakfast">{{ $t('meal_plans.slots.breakfast') }}</option>
                        <option value="lunch">{{ $t('meal_plans.slots.lunch') }}</option>
                        <option value="dinner">{{ $t('meal_plans.slots.dinner') }}</option>
                        <option value="snack">{{ $t('meal_plans.slots.snack') }}</option>
                    </select>
                </div>
                <div class="field">
                    <label>{{ $t('meal_plans.servings') }}</label>
                    <input type="number" min="1" v-model.number="servings" :placeholder="picked_recipe.portions" />
                    <p class="hint">{{ $t('meal_plans.servings_hint') }}</p>
                </div>
            </div>

            <div class="buttons">
                <button type="button" class="primary_btn decline_btn" @click="$emit('decline-action')">{{ $t('meal_plans.back') }}</button>
                <button type="button" class="primary_btn" :disabled="!picked_recipe || !date" @click="save()">{{ $t('meal_plans.save') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MealPlanEntryModal",
    props: [
        'recipes',
        'given_date',
        'given_slot'
    ],
    data() {
        return {
            query: "",
            picked_recipe: null,
            date: this.given_date || null,
            slot: this.given_slot || null,
            servings: null
        }
    },
    computed: {
        filteredRecipes() {
            let query = this.query.trim().toLowerCase();
            let list = this.recipes || [];
            if (query) {
                list = list.filter((recipe) => recipe.name && recipe.name.toLowerCase().includes(query));
            }
            return list.slice(0, 30);
        }
    },
    methods: {
        save() {
            this.$emit('save', {
                date: this.date,
                slot: this.slot,
                recipe_id: this.picked_recipe.id,
                servings: this.servings || null
            });
        }
    }
}
</script>

<style scoped>
.popup {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.6);
}
.entry_modal {
    position: relative;
    max-width: 500px;
    min-width: 260px;
    top: 10%;
    max-height: 75vh;
    overflow-y: auto;
    margin: 1rem auto;
    padding: 2rem;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 0 70px #000000a6;
    text-align: left;
}
.dark .entry_modal {
    background-color: var(--color-bg-primary-dark);
    color: var(--color-text-primary-dark);
}
h4 {
    text-align: center;
    margin-bottom: 1.5rem;
}
.search_input, .field input, .field select {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid var(--color-grey-1);
    border-radius: 6px;
    background-color: transparent;
    color: inherit;
}
.recipe_options {
    list-style: none;
    padding: 0;
    margin: 0.5rem 0 0 0;
    max-height: 40vh;
    overflow-y: auto;
}
.recipe_options li {
    padding: 0.5rem;
    border-bottom: var(--line-dashed);
    cursor: pointer;
}
.recipe_options li:hover {
    color: var(--color-secondary);
}
.recipe_options li.no_results {
    color: var(--color-grey-2);
    cursor: default;
}
.recipe_options li.no_results:hover {
    color: var(--color-grey-2);
}
.picked_name {
    font-weight: bold;
}
.change_link {
    background: none;
    border: none;
    color: var(--color-primary);
    font-size: 0.85rem;
    cursor: pointer;
    text-decoration: underline;
}
.field {
    margin-bottom: 1rem;
}
.field label {
    display: block;
    margin-bottom: 0.2rem;
    font-size: 0.9rem;
}
.hint {
    color: var(--color-grey-2);
    font-size: 0.8rem;
    margin: 0.2rem 0 0 0;
}
.buttons {
    text-align: center;
    margin-top: 1rem;
}
.buttons .primary_btn {
    margin: 0.5rem;
    display: inline-block;
}
.decline_btn {
    background-color: unset;
    color: var(--color-primary);
}
.decline_btn:hover {
    background-color: unset;
    color: var(--color-secondary);
}
</style>
